"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const OperationalContext_1 = __importDefault(require("../OperationalContext/OperationalContext"));
const utils_1 = require("../utils");
const constants_1 = require("../utils/constants");
const styled_1 = __importDefault(require("../utils/styled"));
const BaseSimpleLink = styled_1.default("button", {
    shouldForwardProp: prop => !["color_", "left_", "right_", "as"].includes(prop),
})(({ theme, color_, left_, right_ }) => {
    const actualColor = color_ ? constants_1.expandColor(theme, color_) || color_ : theme.color.primary;
    const hoverColor = utils_1.darken(actualColor, 5);
    return {
        actualColor,
        marginTop: 0,
        marginBottom: 0,
        marginLeft: right_ ? theme.space.base : 0,
        marginRight: left_ ? theme.space.base : 0,
        fontSize: theme.font.size.fineprint,
        fontFamily: theme.font.family.main,
        fontWeight: theme.font.weight.medium,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.borderRadius,
        border: 0,
        position: "relative",
        cursor: "pointer",
        ":focus": Object.assign({}, utils_1.inputFocus({ theme })),
        ":hover": {
            color: hoverColor,
        },
        "& > svg": {
            marginLeft: theme.space.base,
        },
    };
});
const SimpleLink = (_a) => {
    var { to, children, icon: Icon, color, onClick, left, right } = _a, props = __rest(_a, ["to", "children", "icon", "color", "onClick", "left", "right"]);
    return (React.createElement(OperationalContext_1.default, null, ctx => (React.createElement(BaseSimpleLink, Object.assign({}, props, { as: to ? "a" : undefined, left_: left, right_: right, color_: color, href: to, role: "button", "aria-label": typeof children === "string" ? children : undefined, onClick: (ev) => {
            if (onClick) {
                onClick();
            }
            if (!utils_1.isModifiedEvent(ev) && ctx.pushState && to && !utils_1.isOutsideLink(to)) {
                ev.preventDefault();
                ctx.pushState(to);
            }
        } }),
        children,
        Icon && React.createElement(Icon, { right: true, size: 12 })))));
};
exports.default = SimpleLink;
//# sourceMappingURL=SimpleLink.js.map